<script setup lang="ts">
import { useGameStore } from '@/stores/gameStore'
import { computed, ref } from 'vue'
import { useAssetStore } from '@/stores/assetStore.ts'
import CurrentTech from '@/components/Sections/Research/CurrentTech.vue'
import { usePlanetStore } from '@/stores/planetStore.ts'
import GenericIconWithColoredNumber from '@/components/Elements/Images/Icons/GenericIconWithColoredNumber.vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const gameStore = useGameStore()
const assetStore = useAssetStore()
const planetStore = usePlanetStore()

const showScienceToolTip = ref(false)

const techPercentage = computed(() => {
  const tech = assetStore.findTechById(Number(gameStore.player?.currentTechId))
  if (!tech) {
    return 0
  }
  
  let costToUse = tech.cost
  if (gameStore.playerPrototypes.has(tech.id) && gameStore.player?.effectiveAllianceResearchCostMultiplier) {
    costToUse = Math.ceil(tech.cost * gameStore.player.effectiveAllianceResearchCostMultiplier)
  }
  
  const percentage = Math.floor((Number(gameStore.player?.sciencePoints) / costToUse) * 100)
  if (percentage > 100) {
    return 100
  }
  return percentage
})

const scienceOutput = computed(() => {
  if (gameStore.websocketInitialSyncCompleted) {
    return planetStore.getTotalScienceOutput()
  }
  return 0
})
</script>

<template>
  <RouterLink to="/research">
    <div class="sm:block flex-col hidden">
      <div v-if="showScienceToolTip" class="current-tech">
        <CurrentTech></CurrentTech>
      </div>
      <div
        class="bg-slate-700 p-1 rounded-md w-52 flex ps-2 h-7 justify-between"
        @mouseenter="showScienceToolTip = gameStore.player?.currentTechId != 0"
        @mouseleave="showScienceToolTip = false"
      >
        <div class="pr-2">
          <GenericIconWithColoredNumber :amount="scienceOutput" type="science" />
        </div>
        <div class="rounded bg-slate-600 flex-grow h-5 mx-1">
          <div
            v-if="gameStore.player?.currentTechId != 0"
            class="bg-blue-600 h-5 text-blue-100 p-0.5 pl-2 text-center leading-none rounded whitespace-nowrap"
            :style="'width:' + techPercentage + '%'"
          >
            <p class="pt-0.5">{{ techPercentage }}%</p>
          </div>
          <div
            v-else
            class="bg-red-600 p-0.5 text-center leading-none rounded whitespace-nowrap"
            :style="'width:100%'"
          >
            <p class="pt-0.5">{{ t('common.footer.notResearching') }}</p>
          </div>
        </div>
      </div>
    </div>
  </RouterLink>
</template>

<style scoped>
.current-tech {
  position: absolute;
  bottom: 2.5rem;
  z-index: 50;
}
</style>